let getters = {
    GET_SELECTED(state) {
        return state.selected;
    },

    TOTAL_SELECTED(state) {
        return state.selected.length;
    },
};

export default getters;



// WEBPACK FOOTER //
// ./resources/assets/js/components/vuetable2/checkbox/state/getters.js